import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'mb-static-banner',
	templateUrl: './static-banner.component.html',
	styleUrls: ['./static-banner.component.scss']
})
export class StaticBannerComponent {
	@Input() public showStaticBanner: boolean = false;
	@Output() public closeBanner: EventEmitter<void> = new EventEmitter<void>();

	public onClose(): void {
		this.closeBanner.emit();
	}
}
